// @ts-expect-error JS file import
import routeMap from '../routes/routeMap';

export const preloadRoute = (path: string) => {
  const component = routeMap[path];
  if (component && component.preload) {
    component.preload();
  }
};